import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';
import { UserBonusTreeInfoDto } from 'src/api/Api';

import treeItem1 from 'src/assets/img/bonus-game/trees/tree-1.webp';
import treeItem2 from 'src/assets/img/bonus-game/trees/tree-2.webp';
import treeItem3 from 'src/assets/img/bonus-game/trees/tree-3.webp';
import treeItem4 from 'src/assets/img/bonus-game/trees/tree-4.webp';
import treeItem5 from 'src/assets/img/bonus-game/trees/tree-5.webp';
import treeItem6 from 'src/assets/img/bonus-game/trees/tree-6.webp';
import treeItem7 from 'src/assets/img/bonus-game/trees/tree-7.webp';
import treeItem8 from 'src/assets/img/bonus-game/trees/tree-8.webp';
import treeItem9 from 'src/assets/img/bonus-game/trees/tree-9.webp';
import treeItem10 from 'src/assets/img/bonus-game/trees/tree-10.webp';

import { positions } from './constants';
import { bonusGameApi } from 'src/api/bonus-game';

const treeItemsPaths = [
  treeItem1,
  treeItem2,
  treeItem3,
  treeItem4,
  treeItem5,
  treeItem6,
  treeItem7,
  treeItem8,
  treeItem9,
  treeItem10,
];

interface UserContextType {
  gameStat: UserBonusTreeInfoDto;
  setGameStat: (val: UserBonusTreeInfoDto) => void;
  setPromocode: (val: string) => void;
  promocode: string;
  selectredTree: {
    path: string;
    positions: {
      top: string;
      left: string;
    }[];
  };
  setSelectedTree: React.Dispatch<
    React.SetStateAction<{
      path: string;
      positions: {
        top: string;
        left: string;
      }[];
    }>
  >;
}

const UserContext = createContext<UserContextType | null>(null);

export const UserProvider = ({ children }: { children: ReactNode }) => {
  const [gameStat, setGameStat] = useState<UserBonusTreeInfoDto>();
  const [promocode, setPromocode] = useState('');
  const [selectredTree, setSelectedTree] = useState({
    path: treeItemsPaths[0],
    positions: positions[0],
  });

  useEffect(() => {
    if (gameStat) {
      if (gameStat.bonusTreeView) {
        const pos = Number(gameStat.bonusTreeView);
        setSelectedTree({
          positions: positions[pos],
          path: treeItemsPaths[pos],
        });
      }
    }
  }, [gameStat]);

  return (
    <UserContext.Provider
      value={{
        gameStat: gameStat as UserBonusTreeInfoDto,
        setGameStat,
        selectredTree,
        setSelectedTree,
        setPromocode,
        promocode,
      }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => {
  const context = useContext(UserContext);
  if (!context)
    throw new Error('useUserContext must be used within an UserProvider');
  return context;
};
